import firebase from "firebase/app";
import "firebase/firestore"; // If using Firebase frestore
import "firebase/storage"; // If using Firebase storage
import "firebase/auth";

const config = {
  apiKey: "AIzaSyBloms9W8nVUxSPCDBkydF-oXRGELOIXBw",
  authDomain: "form-data-karyawan.firebaseapp.com",
  databaseURL: "https://form-data-karyawan.firebaseio.com",
  projectId: "form-data-karyawan",
  storageBucket: "form-data-karyawan.appspot.com",
  messagingSenderId: "1026412714513",
  appId: "1:1026412714513:web:a5b4607b8d79ebc0502fb0",
  measurementId: "G-Z5S982LXDX",
};

const firebaseConfig = {
  apiKey: "AIzaSyBd5mU_-d-mLzX6BshwelTSpxbnrAUraoQ",
  authDomain: "form-data-karyawan-staging.firebaseapp.com",
  projectId: "form-data-karyawan-staging",
  storageBucket: "form-data-karyawan-staging.firebasestorage.app",
  messagingSenderId: "664714624080",
  appId: "1:664714624080:web:53e28b240b5f900fdde555",
};

// const config = {
//   apiKey: "AIzaSyDw4G6ZW8Ehh6W0UG5b-dZf0-LH_yKOhLg",
//   authDomain: "form-data-karyawan-testing.firebaseapp.com",
//   projectId: "form-data-karyawan-testing",
//   storageBucket: "form-data-karyawan-testing.firebasestorage.app",
//   messagingSenderId: "727688953284",
//   appId: "1:727688953284:web:e984e3c1684acd6a30b891",
// };

firebase.initializeApp(config);
const storage = firebase.storage();

// firebase.firestore().settings(settings);

export { storage, firebase as default };
